import React, { useContext } from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ThemeContext } from "contexts/ThemeContext";

const SiteSelector = ({ userRole, location, selectedSite, sites, clients, handleSiteSelect }) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  // Hide dropdown if on dealer dashboard
  if (userRole === "GLOBAL" && location.pathname === "/dealer/dashboard") return null;

  return (
    <div className="nav-link pr-0 site-selector">
      {userRole === "GLOBAL" ? (
        <UncontrolledDropdown nav inNavbar>
          <DropdownToggle
            caret
            className={`font-weight-bold text-sm ${isDark ? "text-light" : "text-dark"
              }`}
            style={{
              cursor: "pointer",
              background: "transparent",
              border: "none",
              backgroundColor: isDark ? "#212529" : undefined,
              transition: "color 0.2s ease, transform 0.2s ease",
            }}
          >
            <i className="fas fa-map-marker-alt mr-2 text-primary" />
            {selectedSite
              ? `${selectedSite.company_name} (${selectedSite.city || "-"})`
              : "Select Site"}
          </DropdownToggle>

          <DropdownMenu
            right
            className={`border-0 shadow-lg dropdown-fade ${isDark ? "bg-dark text-light" : "bg-white"
              }`}
            style={{
              borderRadius: "10px",
              backdropFilter: "blur(2px)",
              backgroundColor: isDark
                ? "rgba(30, 41, 59, 0.9)"
                : "rgba(255, 255, 255, 0.95)",
              animation: "fadeIn 0.25s ease",
            }}
          >
            {sites.global && sites.global.length > 0 ? (
              sites.global.map((site) => (
                <DropdownItem
                  key={site.site_id || site.company_name}
                  onClick={() => handleSiteSelect(site)}
                  active={selectedSite?.site_id === site.site_id}
                  style={{
                    backgroundColor:
                      selectedSite?.site_id === site.site_id
                        ? (isDark ? "rgba(59, 130, 246, 0.15)" : "#f6f9fc")
                        : "transparent",
                    color: isDark ? "#e5e7eb" : "#111827",
                    transition: "background 0.2s ease, color 0.2s ease",
                  }}
                  onMouseOver={(e) =>
                  (e.target.style.backgroundColor = isDark
                    ? "rgba(59, 130, 246, 0.25)"
                    : "#edf2f7")
                  }
                  onMouseOut={(e) =>
                  (e.target.style.backgroundColor =
                    selectedSite?.site_id === site.site_id
                      ? (isDark ? "rgba(59, 130, 246, 0.15)" : "#f6f9fc")
                      : "transparent")
                  }
                >
                  {site.company_name} ({site.city})
                </DropdownItem>
              ))
            ) : (
              <>
                {clients && clients.length > 0 ? (
                  clients.map((client) => (
                    <div key={client.client_id}>
                      <DropdownItem
                        header
                        className={`font-weight-bold ${isDark ? "text-primary" : "text-primary"
                          }`}
                      >
                        {client.company_name}
                      </DropdownItem>
                      {sites[client.client_id] && sites[client.client_id].length > 0 ? (
                        sites[client.client_id].map((site) => (
                          <DropdownItem
                            key={site.site_id}
                            onClick={() => handleSiteSelect(site)}
                            style={{
                              color: isDark ? "#e5e7eb" : "#111827",
                              transition: "background 0.2s ease",
                            }}
                            onMouseOver={(e) =>
                            (e.target.style.backgroundColor = isDark
                              ? "rgba(59, 130, 246, 0.25)"
                              : "#edf2f7")
                            }
                            onMouseOut={(e) =>
                              (e.target.style.backgroundColor = "transparent")
                            }
                          >
                            {site.company_name} ({site.city})
                          </DropdownItem>
                        ))
                      ) : (
                        <DropdownItem disabled className="text-muted">
                          No sites found
                        </DropdownItem>
                      )}
                      <DropdownItem divider />
                    </div>
                  ))
                ) : (
                  <DropdownItem disabled className="text-muted">
                    No sites found
                  </DropdownItem>
                )}
              </>
            )}
          </DropdownMenu>
        </UncontrolledDropdown>
      ) : (
        <span className="mb-0 text-sm font-weight-bold text-white">
          {selectedSite ? (
            <>
              <i className="fas fa-map-marker-alt mr-2 text-primary" />
              {`${selectedSite.company_name} (${selectedSite.city || "N/A"})`}
            </>
          ) : (
            <span className="text-warning">No Site Selected</span>
          )}
        </span>
      )}
    </div>
  );
};

export default SiteSelector;
